import React, { useRef, useEffect, useState } from 'react';
import { Grid } from "@mui/material";
import { BtnSave } from "components/Button/ButtonAll";
import UploadFile from "components/Input/UploadFile";
import { Extension, FnAxios, FnDialog } from "utilities/utilities";
import { ApiProject } from 'enum/api';
import { APIStatusCode } from 'enum/enum';

const MigrationDataProject = () => {
    const AxiosFn = FnAxios()
    const DialogFn = FnDialog()
    const [arrExcelFile, setArrExcelFile] = useState([]);
    const handleClearAttachFile = useRef(null)

    const onSubmit = (e) => {
        if (arrExcelFile.length === 0 ) { 
            return DialogFn.Warning("กรุณาอัปโหลดไฟล์ข้อมูล");      
        }     

        let param = {
            lstFileUpload: arrExcelFile ?? [],
        };
        DialogFn.Submit("คุณต้องการอัปโหลดไฟล์หรือไม่ ?", () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.SaveDataMigrationProject, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success) {
                    DialogFn.Success("อัปโหลดไฟล์สำเร็จ", ()=> { handleClearAttachFile.current(null); });                
                } else {
                    DialogFn.Warning(result.sMessage);                    
                }                
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    return (
        <Grid item xs={12} md={12} container spacing={1} justifyContent="center">
            <Grid item xs={12} md={12} key={"cFileProject"}>
                <UploadFile
                    key={"oFileDocument"}
                    id={"oFileDocument"}
                    name={"oFileDocument"}
                    label={""}
                    required={false}
                    arrFile={arrExcelFile || []}
                    setarrFile={setArrExcelFile}
                    sFolderTemp="FolderExample"
                    IsFolder={false}
                    IsMultiple={false}
                    Extension={[...Extension.Excel]}
                    nLimitFile={30}
                    sLimitFile={"MB"}
                    onClearFile={handleClearAttachFile}
                    sPositionText="right"
                    IsCrop={false}
                    cropMovable={false}
                    cropResize={false}
                    cropShape="retangle"
                    modeDisplay='list'
                />
            </Grid>            
            <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                <BtnSave id={"btnSave"} onClick={(e) => onSubmit(e)} />
            </Grid>
        </Grid>
    );
}
export default MigrationDataProject